import React from "react";
import { TabsSkeleton } from "frontend/src/ui/tabs-skeleton";
import { PaperTabLayout } from "frontend/src/ui/paper-tab-layout";
import { BusinessOwnerLayout } from "frontend/src/pages/layouts";
import { SearchCatalog } from "frontend/src/domain/tracks";
import { ViewerAddableAudioAdvertisements } from "frontend/src/domain/audio-advertisements";
import { PageSkeleton } from "./skeleton";
import { TimetableRulesetEdit } from "./timetable-rule";
import { TimetableRulesetEditInstruction } from "./instruction";
import { useEditProgram, usePageModel, useViewerAddableAudioAdvertisementList, } from "./model";
var Page = function (_a) {
    var program = _a.program;
    var _b = useEditProgram(program), title = _b.title, entries = _b.entries, isUpdating = _b.isUpdating, submit = _b.submit;
    var advertisements = useViewerAddableAudioAdvertisementList({
        tracks: {
            countMap: entries.trackCountMap,
            add: entries.addTrack,
            remove: entries.removeLastById,
        },
    });
    var tabs = [
        {
            label: "Редактирование",
            node: (React.createElement(TimetableRulesetEdit, { title: {
                    value: title.value,
                    onChange: title.set,
                    error: title.error,
                }, entries: entries.items, isUpdating: isUpdating, onSubmit: submit, onEntryRemove: entries.removeByIndex, onEntryTrackCountChange: entries.changeTrackCount, onEntryPlaylistChange: entries.changePlaylist, onEntryPlaylistDurationChange: entries.changeDuration, onEntryPlaylistPlayOrderChange: entries.changePlayOrder, onPlaylistAdd: entries.addPlaylist })),
        },
        {
            label: "Каталог",
            node: (React.createElement(SearchCatalog, { onTrackAdd: entries.addTrack, onTrackRemove: entries.removeLastById, addedTrackCounter: entries.trackCountMap })),
        },
        {
            label: "Загруженные файлы",
            node: advertisements.items ? (React.createElement(ViewerAddableAudioAdvertisements, { tracks: { items: advertisements.items, empty: advertisements.empty } })) : (React.createElement(React.Fragment, null)),
        },
        {
            label: "Инструкция",
            node: React.createElement(TimetableRulesetEditInstruction, null),
        },
    ];
    return React.createElement(PaperTabLayout, { tabs: tabs, keepMounted: true });
};
export var EditProgramPage = function () {
    var program = usePageModel();
    return (React.createElement(BusinessOwnerLayout, null, program.data ? (React.createElement(Page, { program: program.data })) : (React.createElement(TabsSkeleton, null,
        React.createElement(PageSkeleton, null)))));
};
